import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule, IconModule } from "@hit/coverpath-design-system";
import { EolHomeComponent } from "./eol-home.component";

@NgModule({
    declarations: [EolHomeComponent],
    imports: [CommonModule, ButtonModule, IconModule],
    exports: [EolHomeComponent],
    providers: [],
    bootstrap: [EolHomeComponent]
})
export class EolHomeModule {}
